import { createFileRoute } from '@tanstack/react-router';

import { useOneRosterAuth } from '@/hooks/useOneRosterAuth';

export const Route = createFileRoute('/protected')({
  component: RouteComponent,
});

function RouteComponent() {
  const { isAuthenticated, isLoading, user } = useOneRosterAuth();

  return (
    <div>
      {isLoading && <div>Loading cognito auth...</div>}
      {!isLoading && !isAuthenticated && <div>Not authenticated</div>}
      {isAuthenticated && (
        <div>
          <pre>{JSON.stringify(user, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
